import { render, staticRenderFns } from "./SendConfirmation.vue?vue&type=template&id=70116746"
import script from "./SendConfirmation.vue?vue&type=script&lang=js"
export * from "./SendConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports